__webpack_require__.p = "/MuraqibKsa/";